var map = {
	"./dialogues/dialogues.en.js": [
		2463,
		2463
	],
	"./numbers/numbers.en.js": [
		831,
		831
	],
	"./phrases/phrases.en.js": [
		1887,
		1887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8421;
module.exports = webpackAsyncContext;